<template>
  <LayoutTelas
    id="tela__descontos"
    :titulo="this.$route.meta.titulo"
    :isLoading="isLoading">
    <BForm
      class="form__descontos"
      @submit.prevent="podeGravar">
      <InputBasico
        type="number"
        label="Percentual bonificação por indicação (%)*"
        name="inputPercentual"
        placeholder="Ex. 10"
        class="input__percentual"
        :valMin="0"
        v-model="form.percIndicacao"
        v-validate="'required|min:0'"
        :errorsBag="errors" />

      <div class="botao__container">
        <BButton
          type="submit"
          class="botao"
          variant="primary">
          Gravar
        </BButton>

        <BButton
          @click.prevent="sair"
          class="botao"
          variant="outline-primary">
          Sair
        </BButton>
      </div>
    </BForm>
  </LayoutTelas>
</template>

<script>
import { BForm, BButton } from 'bootstrap-vue/es/components'
import InputBasico from '@/components/inputs/InputBasico.vue'
import GeradorMensagens from '@/mixins/GeradorMensagens'

import descontoService from '../../services/desconto.service'

export default {
  name: 'Descontos',
  components: {
    BForm,
    BButton,
    InputBasico,
  },
  mixins: [GeradorMensagens],
  data() {
    return {
      isLoading: false,
      form: this.retornaValoresIniciaisForm(),
    }
  },
  mounted() {
    this.carregar()
  },
  methods: {
    retornaValoresIniciaisForm() {
      return {
        percIndicacao: '',
      }
    },
    podeGravar() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.gravar()
        }
      })
    },
    async gravar() {
      this.mostrarLoader()
      try {
        const retorno = await this.retornaMetodoGravacao(this.form)
        this.tratarRespostaMsg(retorno)
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },
    retornaMetodoGravacao(dados) {
      return dados._id
        ? descontoService.atualizar(dados)
        : descontoService.gravar(dados)
    },
    async carregar() {
      this.mostrarLoader()
      try {
        const retorno = await descontoService.retornaTodos()
        if (retorno.lista.length > 0) {
          this.form = { ...retorno.lista[0] }
        }
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },
    mostrarLoader(mostrar = true) {
      this.isLoading = mostrar
    },
    sair() {
      this.$router.push({ name: 'rota-dashboard' })
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";

#tela__descontos {
  display: flex;
  flex-direction: column;
  max-width: 100%;

  @media (min-width: $medium-size) {
    min-width: $small-size;
  }
}

.botao {
  margin-left: .2rem;

  &__container {
    margin-top: 1rem;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
  }
}

</style>
